<app-page-layout [title]="'CHOOSE_MODE'" [displayCustomerService]="false">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 col-md-offset-3">
                <mat-card>
                    <mat-card-content>
                        <ul class="row no-margin-padding">
                            <h3 class="center">{{'HUB.CHOOSE_MODE' | translate}}</h3>
                            <li class="col-md-6 unstyle dual-choice">
                                <div class="choice" (click)="manageAccessService.hubChoice(service.telemetry)">
                                    <mat-icon class="icon-choice">gas_meter</mat-icon>
                                </div>
                                <h6 class="h6-choice">{{'HUB.TELEMETRY' | translate}}
                                </h6>
                            </li>
                            <li class="col-md-6 unstyle dual-choice">
                                <div class="choice" (click)="manageAccessService.hubChoice(service.alert)">
                                    <mat-icon class="icon-choice">elderly_woman</mat-icon>
                                </div>
                                <h6 class="h6-choice">{{'HUB.ALERT' | translate}}</h6>
                            </li>
                        </ul>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</app-page-layout>